module.exports = __webpack_public_path__ + "static/media/Shipping Crisis Explainer Video Script_1627306431359.8da0c976.docx";